var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{staticClass:"overlay",attrs:{"opacity":1,"absolute":false}},[_c('unauthorized-message')],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }